export const JOURNEY_TABS = [
    { key: 'welcome', title: 'Welcome' },
    { key: 'welcome_offer', title: 'Welcome Offer' },
    { key: 'can_pickup', title: 'Can Pickup' },
    { key: 'customer_initiated', title: 'Menu' },
    { key: 'order_confirmation', title: 'Order Confirmation' },
    { key: 'offer_50', title: '50 Pack' },
    { key: 'offer_100', title: '100 Pack' },
    { key: 'wallet_low', title: 'Low Wallet' },
    { key: 'refer', title: 'Refer' }
];

export const STAGE_LABELS = {
    first_delivery: 'First delivery',
    day4_feedback: 'Day 4 feedback',
    day4_review_reminder: 'Day 4 review reminder',
    day15_offer: 'Day 15 offer',
    day15_reengage: 'Day 15 re-engage',
    day15_payment_reminder: 'Payment retry',
    day15_offer_expiring: 'Offer expiring',
    offer_payment_success: 'Payment received',
    day25_reach: 'Day 25 reach out',
    day30_reach: 'Day 30 reach out',
    day45_retention: 'Day 45 retention',
    pickup_schedule: 'Pickup notice',
    pickup_confirmed: 'Pickup confirmed',
    pickup_reminder: 'Pickup reminder',
    pickup_completed: 'Pickup completed',
    pickup_not_completed: 'Pickup not completed',
    menu: 'Customer menu',
    order_confirmation: 'Delivery confirmation',
    purchase_confirmation: 'Purchase confirmation',
    offer_50: '50 Pack offer',
    offer_100: '100 Pack offer',
    welcome_offer_nudge: 'Welcome offer nudge',
    welcome_offer_confirmed: 'Welcome offer confirmed',
    wallet_low_10: 'Low wallet, 10 pack',
    wallet_low_50: 'Low wallet, 50 pack',
    wallet_low_100: 'Low wallet, 100 pack',
    refer_lvlup: 'Refer and earn'
};

export const humanize = (key) => {
    const text = String(key).replace(/_/g, ' ');
    return text.charAt(0).toUpperCase() + text.slice(1);
};

export const stageLabel = (stage) => STAGE_LABELS[stage] || humanize(stage);

export const formatIstDateTime = (value) => {
    if (!value) return '-';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '-';
    return date.toLocaleString('en-IN', {
        timeZone: 'Asia/Kolkata',
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
};

export const journeyLabel = (journey) => {
    const tab = JOURNEY_TABS.find(({ key }) => key === journey);
    return tab ? tab.title : humanize(journey);
};

export const OFFER_LABELS = {
    welcome_10_2: 'Welcome 10+2',
    welcome_180: 'Welcome Offer (Rs 180)',
    pack_10: '10 Pack',
    pack_50: '50+5 Pack',
    pack_50_followup: '50 Pack (low wallet)',
    pack_100: '100 Pack'
};

export const NON_CYCLE_OFFERS = ['welcome_10_2', 'welcome_180'];

// Pack cycles are YYYY-MM; the one-time welcome offer is stored under the key `once`
export const isCycleKey = (key) => /^\d{4}-\d{2}$/.test(String(key || ''));

export const OFFER_STATUS_LABELS = {
    offered: 'Offered',
    link_created: 'Link created',
    paid: 'Paid',
    failed: 'Failed',
    expired: 'Expired',
    closed: 'Closed'
};

export const SUPPORT_STATUS_LABELS = {
    open: 'Open',
    in_progress: 'In progress',
    resolved: 'Closed',
    dismissed: 'Dismissed'
};

export const SUPPORT_TYPE_LABELS = {
    call_me: 'Call Me',
    talk_to_support: 'Talk to Support',
    report_issue: 'Report an Issue',
    auto_pickup_review: 'Pickup Review',
    concern: 'Concern'
};

export const ISSUE_CATEGORY_LABELS = {
    water_quality: 'Water Quality/Taste',
    seal_or_can: 'Seal or Can Issue',
    delivery_issue: 'Delivery Issue',
    app_or_payment: 'App or Payment Issue',
    request_call: 'Request a Call',
    price: 'Price',
    delivery_experience: 'Delivery Experience',
    app_issue: 'App Issue',
    other: 'Other'
};

export const offerLabel = (offerKey) => OFFER_LABELS[offerKey] || humanize(offerKey);

export const supportTypeLabel = (type) => SUPPORT_TYPE_LABELS[type] || humanize(type);

export const issueCategoryLabel = (category) => ISSUE_CATEGORY_LABELS[category] || humanize(category);

// Pack cycles are IST calendar months stored as YYYY-MM
export const formatCycle = (cycleKey) => {
    if (!cycleKey) return '-';
    const [year, month] = cycleKey.split('-').map(Number);
    if (!year || !month) return cycleKey;
    return new Date(Date.UTC(year, month - 1, 1)).toLocaleDateString('en-IN', { timeZone: 'UTC', month: 'short', year: 'numeric' });
};

export const formatMoney = (value) => (
    Number.isFinite(value) ? `₹${value.toLocaleString('en-IN', { maximumFractionDigits: 2 })}` : '-'
);

// Elapsed time between two instants as the two largest units, for example 3d 4h, 2h 15m or 12m
export const formatAge = (from, to = new Date()) => {
    const start = new Date(from).getTime();
    const end = new Date(to).getTime();
    if (Number.isNaN(start) || Number.isNaN(end)) return '-';
    const minutes = Math.max(Math.floor((end - start) / 60000), 0);
    const days = Math.floor(minutes / 1440);
    const hours = Math.floor((minutes % 1440) / 60);
    if (days > 0) return `${days}d ${hours}h`;
    if (hours > 0) return `${hours}h ${minutes % 60}m`;
    return `${minutes}m`;
};

// Hours as a short duration, for example 1.5 -> 1h 30m
export const formatHours = (hours) => {
    if (!Number.isFinite(hours)) return '-';
    return formatAge(0, Math.round(hours * 3600000));
};
